var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.06,
    height: 52.043,
    viewBox: "0 0 52.06 52.043",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "noun-close-4953021",
    d: "M61.444,58.276A2.226,2.226,0,0,1,58.3,61.424L37.861,40.99a.741.741,0,0,0-1.048,0L16.378,61.424a2.226,2.226,0,0,1-3.148-3.148L33.663,37.841a.742.742,0,0,0,0-1.048L13.23,16.358a2.226,2.226,0,0,1,3.148-3.148L36.813,33.643a.741.741,0,0,0,1.048,0L58.3,13.21a2.226,2.226,0,0,1,3.148,3.148L41.01,36.793a.742.742,0,0,0,0,1.048Z",
    transform: "translate(-11.307 -11.287)",
    fill: "#2c53bb",
    stroke: "#2c53bb",
    strokeWidth: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/Cancel.8322ca210e4833cfeef255d9ba6c5df5.svg";
export { ForwardRef as ReactComponent };